import type { ReadinessValue } from '@aikoa/common'
import { useTranslations, type TFunction } from '@aikoa/i18n/react'
import { MatchBadge } from '~/components/ui/match-badge'

function readinessToScore(value: ReadinessValue): number {
  if (value === 1) return 4
  if (value === 0.8) return 3
  if (value === 0.6) return 2
  return 1
}

function getReadinessLabel(value: ReadinessValue, t: TFunction<'leads'>): string {
  switch (value) {
    case 1:
      return t(($) => $.detail.readiness.readyToMove)
    case 0.8:
      return t(($) => $.detail.readiness.activelySearching)
    case 0.6:
      return t(($) => $.detail.readiness.sellingFirst)
    case 0.3:
      return t(($) => $.detail.readiness.earlyStage)
    case 0:
      return t(($) => $.detail.readiness.notTimely)
  }
}

interface ReadinessBadgeProps {
  readiness: ReadinessValue | null
  label?: string
  className?: string
  variant?: 'default' | 'inverted'
}

export default function ReadinessBadge({
  readiness,
  label: customLabel,
  variant = 'default',
  className,
}: ReadinessBadgeProps) {
  const { t } = useTranslations('leads')

  if (readiness === null) {
    return null
  }

  const score = readinessToScore(readiness)
  const label = customLabel ?? getReadinessLabel(readiness, t)

  return <MatchBadge score={score} variant={variant} label={label} className={className} />
}
